__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/2fce8942c1ba1891059275b1077fdc4170b94a1f/_next/";